module.exports = __webpack_public_path__ + "static/media/Aleris uses telemedicine software for digital patient care.078e498d.webp";